module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interviews":"interview | interviews | interviews","sms":"text message | text messages | text messages","calls":"calls | call | calls"}}')
  delete Component.options._Ctor
}
